import { Component, OnInit,Input } from '@angular/core';
import { VgApiService } from '@videogular/ngx-videogular/core';

@Component({
  selector: 'app-paudio',
  templateUrl: './paudio.component.html',
  styleUrls: ['./paudio.component.sass']
})
export class PaudioComponent implements OnInit {
  @Input('res') response: object;
  @Input('pathToMedia') pathToMedia: string;
  @Input('className') className: string;
  api: VgApiService;
  constructor() { }

  ngOnInit(): void {
   
  }

  playAudio() {
    this.api.play();
  
  }

  onPlayerReady(api: VgApiService) {
    this.api = api;

    this.api.getDefaultMedia().subscriptions.loadedMetadata.subscribe(this.playAudio.bind(this));
   }

}
